import { useState } from "react";
import { Page } from "../../SignedOut/Cadastro/styles";
import SidebarMenu from "../../../Components/SidebarMenu";
import api from "../../../Services/api";
import {
	InputCPF,
	InputDescription,
	SearchButton,
	InfosText,
	LoadingText,
	InputAndButtonContainer,
	PageTitle,
	TitleText,
	InputProcedimento,
	Background,
	TokenContainer,
} from "./styles";
import { toast } from "react-toastify";
import { useAuth } from "../../../Hooks/useAuth";
import PageContainer from "../../../Components/PageContainer";
import CreatableSelect from "react-select/creatable";
import ReactLoading from "react-loading";
import { CardGerarPagamento } from "../../../Components/CardGerarPagamento";
import QRCode from "react-qr-code";

export default function Pagamento() {

	const [isLoadingBuscaPacienteOuAfiliado, setIsLoadingBuscaPacienteOuAfiliado] = useState(false);
	const [isLoadingPayment, setIsLoadingPayment] = useState(false);
	const [pacienteOuAfiliados, setPacienteOuAfiliados] = useState(null);
	const [nomePacienteOuAfiliado, setNomePacienteOuAfiliado] = useState(null);
	const [token, setToken] = useState(null);
	const [especialidade, setEspecialidade] = useState(null);

	const { user } = useAuth();

	const showToastMessageError = (mensagem) => { //Exibe mensagem de erro ao topo
		toast.error(mensagem, { position: toast.POSITION.TOP_CENTER });
	};

	const handleSearchPacienteOuAfiliado = async () => { //Pesquisar usuarios
		if (!nomePacienteOuAfiliado) { //Verifica se o campo está vazio
			showToastMessageError("Pesquise por um nome");
			setPacienteOuAfiliados(null);
			return;
		}

		setIsLoadingBuscaPacienteOuAfiliado(true); //Começa a exibir o loading

		try {
			const response = await api.get(`/usuario/por_nome?nome=${nomePacienteOuAfiliado}`);
			setPacienteOuAfiliados(response.data);
		} catch (error) {
			console.log(error);
			showToastMessageError("Não foi possível encontrar o paciente ou afiliado");
			setPacienteOuAfiliados(null);
		} finally {
			setIsLoadingBuscaPacienteOuAfiliado(false); //Para o loading
		}
	};

	const handleGeneratePaymentConsulta = async (email) => {
		setIsLoadingPayment(true);

		try {
			const especialidadeSelecionada = user.medico.especialidades.find(
				(objeto) => objeto.NO_especialidade === especialidade
			);

			if (!especialidadeSelecionada) {
				showToastMessageError("Especialidade não encontrada.");
				setIsLoadingPayment(false);
				return;
			}

			const response = await api.post(`/transferencia/gerar-transferencia`, {
				email_cobrado: email,
				especialidade_id: especialidadeSelecionada.id_especialidade,
			});

			setToken(response.data.CD_token);
		} catch (error) {
			console.error("Erro ao gerar cobrança de consulta:", error);
			showToastMessageError("Erro ao gerar cobrança de consulta.");
		} finally {
			setIsLoadingPayment(false);
		}
	};

	const handleGeneratePaymentProcedimento = async (email, nomeDoProcedimento, valor) => {
		setIsLoadingPayment(true);

		try {
			if (!email || !nomeDoProcedimento || !valor) {
				showToastMessageError("Preencha todos os campos para gerar o pagamento do procedimento.");
				return;
			}

			const response = await api.post(`/transferencia/gerar-transferencia-personalizada`, {
				descricao: nomeDoProcedimento,
				email_cobrado: email,
				QT_creditos: valor,
			});

			if (response.data && response.data.CD_token) {
				setToken(response.data.CD_token);
			} else {
				showToastMessageError("Não foi possível gerar o token de pagamento.");
			}
		} catch (error) {
			console.error("Erro ao gerar cobrança de procedimento:", error);
			showToastMessageError("Erro ao gerar cobrança de procedimento.");
		} finally {
			setIsLoadingPayment(false);
		}
	};

	const customStyles = {
		control: (provided, state) => ({
			...provided,
			width: "30vw",
			minHeight: "30px",
			borderRadius: "10px",
			backgroundColor: "#fafafa",
			fontSize: "18px",
			color: "black",
			border: "1px solid #d5d5d5",
		}),
		option: (provided, state) => ({
			...provided,
			color: "black", // Cor do texto das opções
		}),
	};

	const formattedList = user.medico.especialidades ? user.medico.especialidades.map((especialidade) => {
		return { label: especialidade.NO_especialidade, value: especialidade.NO_especialidade };
	}) : [];

	formattedList.unshift({ label: "Procedimento Médico", value: null });

	return (
		<Page>
			<SidebarMenu />
			<Background>
				<PageContainer>
					<PageTitle>Gerar Pagamento</PageTitle>

					<InputDescription>Selecione a Especialidade</InputDescription>

					<CreatableSelect
						options={formattedList}
						id="Especialidades"
						name="Especialidades"
						required
						onChange={(e) => {
							setEspecialidade(e.value);
						}}
						styles={customStyles}
						placeholder={"Selecione as especialidades"}
					/>

					{/* Campo de busca e botão de pesquisa */}
					<InputDescription>
						{especialidade ? "Gere o pagamento da CONSULTA" : "Gere o pagamento do PROCEDIMENTO"}
					</InputDescription>

					<InputAndButtonContainer>
						{especialidade ? (
							<InputCPF
								placeholder="Digite o nome do paciente ou afiliado"
								maskChar={null}
								value={nomePacienteOuAfiliado}
								onChange={(event) => setNomePacienteOuAfiliado(event.target.value)}
							/>
						) : (
							<InputProcedimento
								placeholder="Digite o nome do paciente ou afiliado"
								maskChar={null}
								value={nomePacienteOuAfiliado}
								onChange={(event) => setNomePacienteOuAfiliado(event.target.value)}
							/>
						)}
						<SearchButton disabled={isLoadingBuscaPacienteOuAfiliado} onClick={handleSearchPacienteOuAfiliado}>
							{isLoadingBuscaPacienteOuAfiliado ? (
								<ReactLoading
									type="spin"
									color="#ffffff"
									height={"30px"}
									width={"30px"}
									className="m-auto"
								/>
							) : "Pesquisar"}
						</SearchButton>
					</InputAndButtonContainer>

					{isLoadingBuscaPacienteOuAfiliado && (
						<LoadingText>Carregando perfil do paciente...</LoadingText>
					)}

					{isLoadingPayment ? (
						<LoadingText>Gerando token...</LoadingText>
					) : token && (
						<TokenContainer>
							<InfosText>
								Token de Pagamento: <TitleText>{token}</TitleText>
							</InfosText>
							<div style={{ background: 'white', padding: '16px', borderRadius: '8px' }}>
								<QRCode value={token} size={200} />
							</div>
						</TokenContainer>
					)
					}

					{pacienteOuAfiliados && pacienteOuAfiliados.length > 0 && pacienteOuAfiliados.map((pacienteOuAfiliado) => (
						<CardGerarPagamento
							key={pacienteOuAfiliado.id}
							usuario={pacienteOuAfiliado}
							gerar={especialidade ? handleGeneratePaymentConsulta : handleGeneratePaymentProcedimento}
							isLoadingPayment={isLoadingPayment}
							tipo={especialidade ? "consulta" : "procedimento"}
						/>
					))}
				</PageContainer>
			</Background>
		</Page>
	);
}